import { c as _c } from "react/compiler-runtime";
import { getUploadImageKey } from '@onefootprint/core';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
import useDocuments from '@/entity/hooks/use-documents';
export const parseDocumentIdentifier = (documentIdentifier: string) => {
  const match = documentIdentifier.match(/^(.*):(\d+)$/);
  if (!match) return null;
  const version = Number(match[2]);
  if (!Number.isSafeInteger(version)) return null;
  return {
    identifier: match[1],
    version
  };
};
export const findDocumentUpload = (documents: TransformedDocument[] | undefined, documentIdentifier: string, includeProcessedImages = false): {
  document: TransformedDocument;
  upload: TransformedDocument['uploads'][number];
} | null => {
  for (const document of documents ?? []) {
    const upload = document.uploads.find(candidate => `${candidate.identifier}:${candidate.version}` === documentIdentifier || includeProcessedImages && getUploadImageKey(candidate) === documentIdentifier);
    if (upload) return {
      document,
      upload
    };
  }
  return null;
};
const useVaultDocument = (entityId, documentIdentifier, t0) => {
  const $ = _c(21);
  const includeProcessedImages = t0 === undefined ? false : t0;
  let t1;
  if ($[0] !== documentIdentifier) {
    t1 = parseDocumentIdentifier(documentIdentifier);
    $[0] = documentIdentifier;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const parsedIdentifier = t1;
  const current = useDocuments(entityId ?? "");
  let t2;
  if ($[2] !== current.data || $[3] !== documentIdentifier || $[4] !== includeProcessedImages) {
    t2 = findDocumentUpload(current.data, documentIdentifier, includeProcessedImages);
    $[2] = current.data;
    $[3] = documentIdentifier;
    $[4] = includeProcessedImages;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const currentMatch = t2;
  const shouldFetchHistorical = current.isSuccess && !currentMatch && !!parsedIdentifier;
  const historical = useDocuments(shouldFetchHistorical ? entityId ?? "" : "", parsedIdentifier?.version);
  let t3;
  if ($[6] !== documentIdentifier || $[7] !== historical.data || $[8] !== includeProcessedImages) {
    t3 = findDocumentUpload(historical.data, documentIdentifier, includeProcessedImages);
    $[6] = documentIdentifier;
    $[7] = historical.data;
    $[8] = includeProcessedImages;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const historicalMatch = t3;
  const t4 = currentMatch ?? historicalMatch;
  const t5 = parsedIdentifier?.version;
  const t6 = current.isPending || shouldFetchHistorical && historical.isPending;
  const t7 = current.error ?? historical.error;
  let t8;
  if ($[10] !== current || $[11] !== historical || $[12] !== shouldFetchHistorical) {
    t8 = () => shouldFetchHistorical ? historical.refetch() : current.refetch();
    $[10] = current;
    $[11] = historical;
    $[12] = shouldFetchHistorical;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = current.isSuccess && !currentMatch && (!parsedIdentifier || historical.isSuccess && !historicalMatch);
  let t10;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t10 = {
      match: t4,
      version: t5,
      isLoading: t6,
      error: t7,
      retry: t8,
      isUnavailable: t9
    };
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default useVaultDocument;